import { render, staticRenderFns } from "./SystemsCarouselItem.vue?vue&type=template&id=05c5fccc&scoped=true&"
import script from "./SystemsCarouselItem.vue?vue&type=script&lang=js&"
export * from "./SystemsCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./SystemsCarouselItem.vue?vue&type=style&index=0&id=05c5fccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5fccc",
  null
  
)

export default component.exports